import type { Directive } from 'vue';

import { createDirectiveRegistry, onClickOutside } from '@emobg/web-utils';

const registry = createDirectiveRegistry();

export const ClickOutside: Directive = {
  mounted(element, binding) {
    const cleanup = onClickOutside(element, binding.value, {
      bubble: Boolean(binding.modifiers.bubble),
    });
    registry.save(element, cleanup);
  },
  unmounted(element) {
    registry.clean(element);
  },
} as const;
